import {
  ActionsContainer,
  Card,
  CompanyName,
} from "../companyCard/companyCard.styles";
import { Icon } from "../input/input.styles";
import NoCompanyIcon from "../../assets/icons/noCompany.svg";
import DeleteIcon from "../../assets/icons/delete.svg";
import EditIcon from "../../assets/icons/edit.svg";
import Image from "../Image/Image.component";
import { AppsType } from "../../routes/admin/dashboard/apps/Apps.route";

export default function AppCard({
  id,
  name,
  description,
  picture_url,
  toggleConfirmationModal,
  toggleEditModal,
  setAppId,
}: AppsType & {
  toggleConfirmationModal: () => void;
  toggleEditModal: () => void;
  setAppId: (id: number) => void;
}) {
  return (
    <Card>
      <Image
        src={picture_url}
        onError={(e) => {
          e.currentTarget.src = NoCompanyIcon;
        }}
        className="w-[90px] h-[90px] object-contain mb-6"
        alt={`${name} Picture`}
      />
      <CompanyName className="capitalize mx-auto">{name}</CompanyName>
      <ActionsContainer>
        <button
          onClick={() => {
            toggleEditModal();
            id && setAppId(id);
          }}
        >
          <Icon src={EditIcon} title="Edit" />
        </button>
        <button
          onClick={() => {
            toggleConfirmationModal();
            id && setAppId(id);
          }}
        >
          <Icon src={DeleteIcon} title="Delete" />
        </button>
      </ActionsContainer>
    </Card>
  );
}
